import { Button } from '@fluentui/react-components';
import { EditRegular, OpenRegular } from '@fluentui/react-icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { iconButtonStyles } from '../../app/common/styles/CommonStyleObjects';
import IDividends from '../../utils/types/IDividends';
import CanAccess from './canAccess/CanAccess';

interface IDividendsLinkProps {
  dividends: IDividends;
  companyCode: string;
  toggleDividendsPanel: () => void;
}

const DividendsLink = ({
  dividends,
  companyCode,
  toggleDividendsPanel,
}: IDividendsLinkProps): JSX.Element => {
  if (dividends?.dividendReviewId) {
    return (
      <Link
        aria-label="Dividends Review"
        to={`/companies/${companyCode}/dividends-review/${dividends.dividendReviewId}`}
      >
        <OpenRegular />
      </Link>
    );
  }

  return (
    <CanAccess requestedAction="DividendInfo:Update">
      <Button
        appearance="subtle"
        title="Edit Dividends"
        aria-label="Edit Dividends"
        icon={<EditRegular color={iconButtonStyles.color} />}
        onClick={toggleDividendsPanel}
      />
    </CanAccess>
  );
};

export default DividendsLink;
